import { render, staticRenderFns } from "./button-widget.vue?vue&type=template&id=d72c8398&scoped=true"
import script from "./button-widget.vue?vue&type=script&lang=js"
export * from "./button-widget.vue?vue&type=script&lang=js"
import style0 from "./button-widget.vue?vue&type=style&index=0&id=d72c8398&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72c8398",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d72c8398')) {
      api.createRecord('d72c8398', component.options)
    } else {
      api.reload('d72c8398', component.options)
    }
    module.hot.accept("./button-widget.vue?vue&type=template&id=d72c8398&scoped=true", function () {
      api.rerender('d72c8398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/button-widget.vue"
export default component.exports